import { anthropicLegBadge, type ModelCatalogEntry } from "@dosia/shared";

export { anthropicLegBadge };

export type PriorityBadge = "native" | "translated" | "unknown" | "pi" | "no_brain_leg";

export function priorityBadgeLabel(badge: PriorityBadge): string {
  switch (badge) {
    case "native": return "原生 SDK";
    case "translated": return "网关翻译";
    case "unknown": return "协议待核";
    case "pi": return "pi 引擎";
    case "no_brain_leg": return "已供给 · 无主脑腿";
  }
}

export function priorityBadgeClassName(badge: PriorityBadge): string {
  if (badge === "translated" || badge === "no_brain_leg") return "text-dosia-warning";
  if (badge === "unknown") return "text-dosia-text-secondary";
  return "text-dosia-accent";
}

export function priorityBadgeTitle(badge: PriorityBadge): string {
  switch (badge) {
    case "native": return "这条 Anthropic 腿由上游原生支持";
    case "translated": return "这条 Anthropic 腿由网关转译";
    case "unknown": return "这条腿的原生性未知，可能是旧版网关或灰度字段";
    case "pi": return "这条优先级项使用 pi 执行引擎";
    case "no_brain_leg": return "模型已供给，但没有可当 Claude 主脑的 Anthropic 协议腿";
  }
}

export function priorityOptionBadge(option: {
  chain: "claude" | "pi";
  entry?: Pick<ModelCatalogEntry, "protocol" | "translated">;
}): PriorityBadge {
  if (option.chain === "pi") return "pi";
  return anthropicLegBadge(option.entry) ?? "unknown";
}
